import { Box, styled } from "@mui/material";

export const BoxDetailContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: theme.spacing(3),
    gap: theme.spacing(1),

    [theme.breakpoints.up("md")]: {
        paddingLeft: theme.spacing(4),
    },
}));

export const BoxRow = styled(Box)(({ theme }) => ({
    display: "flex",
    paddingTop: theme.spacing(1),
    gap: theme.spacing(1),
}));
